var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 14.833C7.264 14.833 6.85067 14.663 6.51 14.323C6.17 13.9823 6 13.569 6 13.083V3.41699C6 2.93099 6.17 2.51766 6.51 2.17699C6.85067 1.83699 7.264 1.66699 7.75 1.66699H14.917C15.403 1.66699 15.816 1.83699 16.156 2.17699C16.4967 2.51766 16.667 2.93099 16.667 3.41699V13.083C16.667 13.569 16.4967 13.9823 16.156 14.323C15.816 14.663 15.403 14.833 14.917 14.833H7.75ZM7.75 13.083H14.917V3.41699H7.75V13.083ZM4.25 18.333C3.764 18.333 3.35067 18.163 3.01 17.823C2.67 17.4823 2.5 17.069 2.5 16.583V5.93799C2.5 5.70133 2.58667 5.49633 2.76 5.32299C2.934 5.14899 3.139 5.06199 3.375 5.06199C3.611 5.06199 3.816 5.14899 3.99 5.32299C4.16333 5.49633 4.25 5.70133 4.25 5.93799V16.583H12.396C12.632 16.583 12.8367 16.67 13.01 16.844C13.184 17.0173 13.271 17.222 13.271 17.458C13.271 17.694 13.184 17.899 13.01 18.073C12.8367 18.2463 12.632 18.333 12.396 18.333H4.25ZM7.75 3.41699V13.083V3.41699Z",
    fill: "#22292F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.71504e9d93ff2434a55df15b55370bb9.svg";
export { ForwardRef as ReactComponent };